import React from 'react'
import { Select, SelectOption, ToggleBar, ToggleBarButton } from 'components/Zui'
import './index.css'

const Index = ({ isDisabled, value, onChange, options }) => {
    return (
        <>
            <div className="filter-toggle-bar">
                <ToggleBar
                    emphasis="selected"
                    size="s"
                    value={value}
                    theme="zbds-dark"
                    onChange={e => {
                        if (!isDisabled) onChange(e.target.value)
                    }}
                >
                    {options.map(filter => (
                        <ToggleBarButton value={filter.value} key={filter.value}>
                            {filter.label} ({filter.count})
                        </ToggleBarButton>
                    ))}
                </ToggleBar>
            </div>
            <div className="files-button-filter">
                <Select
                    theme="zbds-dark"
                    value={[value]}
                    onChange={e => {
                        if (!isDisabled) onChange(e.target.value[0])
                    }}
                >
                    {options.map(f => (
                        <SelectOption value={f.value} key={f.value} selected={value === f.value}>
                            {f.label} ({f.count})
                        </SelectOption>
                    ))}
                </Select>
            </div>
        </>
    )
}

export default React.memo(Index)
